// @flow
import React from 'react'

const TShirt = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#6E7B8C"
        strokeLinecap="square"
        d="M15.5.5c0 2.2-1.8 4-4 4s-4-1.8-4-4h-3l-4 2v6h4v12h14v-12h4v-6l-4-2h-3z"
      />
    </svg>
  )
}

export default TShirt



// WEBPACK FOOTER //
// ./src/components/Icons/TShirt.js